import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "relative",
    "& .MuiTab-wrapper": {
      color: theme.palette.secondary.main,
    },
  },
  appBar: {
    backgroundColor: "inherit",
    borderBottom: `1px solid ${theme.palette.secondary.tint15}`,
    "& .MuiButtonBase-root": {
      color: theme.palette.secondary.main,
    },
  },

  extraText: {
    height: theme.spacing(25),
    margin: theme.spacing(0, 1),
    position: "absolute",
    right: 0,
    top: 0,
    display: "flex",
    alignItems: "center",
    height: theme.spacing(16),
  },
  action: {
    width: "20%",
  },
  smallTabs: {
    "& button": {
      paddingTop: 0,
      paddingBottom: 0,
      minWidth: [theme.spacing(40), "!important"],
    },
  },
  small: {
    maxHeight: theme.spacing(16),
    minHeight: theme.spacing(16),
    display: "flex",
    alignItems: "center",
    "& .MuiTabs-flexContainer": {
      height: theme.spacing(16),
    },
    "& button": {
      paddingTop: 0,
      paddingBottom: 0,
      height: theme.spacing(16),
      minHeight: theme.spacing(16),
      minWidth: theme.spacing(25),
      maxWidth: theme.spacing(25),
      color: theme.palette.secondary.main,
    },
  },
}));
